import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { GlobalModule } from 'src/app/global/global.module';
import { SeekDashboardComponent } from './seek-dashboard/seek-dashboard.component';

@NgModule({
  declarations: [SeekDashboardComponent],
  imports: [CommonModule, GlobalModule, TabViewModule],
})
export class SeekModule {}
